export default __webpack_public_path__ + "static/media/diked_layout.38887242.jpg";